<template>
  <q-item class="reminder-item">
    <div class="q-item__section--main flex-auto">
      <q-item-label
        v-if="!hideTitle"
        class="text-bold q-pt-sm q-pb-xs opaque-80"
        :class="{'disabled': disable}"
      >
        Reminder {{ index + 1 }}
      </q-item-label>
      <div class="flex q-gutter-sm items-start">
        <template v-if="!disableType">
          <MessageTypeSelect
            v-model="reminder.type"
            :disable="disable"
            style="flex: 1 0 100px;"
            @update:model-value="onChangeType"
          />
          <EmailInput
            v-if="reminder.type === 'EMAIL'"
            v-model="reminder.value"
            style="flex: 1 0 220px;"
            :disable="disable"
            :default-email="defaultEmail"
            :suggestions="emailSuggestions"
            :prefill-hint="emailPrefillHint"
            @focus="$emit('emailFocus')"
          />
          <MobilePhoneInput
            v-else-if="reminder.type === 'SMS'"
            v-model="reminder.value"
            style="flex: 1 0 220px;"
            :disable="disable"
            :default-phone="defaultPhone"
            :suggestions="phoneSuggestions"
            :prefill-hint="phonePrefillHint"
            @focus="$emit('phoneFocus')"
          />
        </template>

        <minute-picker
          v-if="!realTime"
          v-model="reminder.reminder_offset"
          :disable="disable || reminder.type === 'NONE'"
          dense
          style="flex: 1 0 200px;"
          v-bind="minutePickerProps"
        />
      </div>
    </div>
    <q-item-section
      v-if="!disable"
      side
      top
    >
      <cancel-button
        :style="{'margin-top': !hideTitle ? '38px' : '8px'}"
        flat
        selector=".reminder-item"
        hover-selector-class="bg-red-1"
        @click="$emit('remove')"
      />
    </q-item-section>
  </q-item>
</template>

<script>
import MessageTypeSelect from 'components/partials/communications/reminders/MessageTypeSelect'

import EmailInput from 'components/partials/communications/reminders/messageTypes/EmailInput'
import MobilePhoneInput from 'components/partials/communications/reminders/messageTypes/MobilePhoneInput'

/**
 * ReminderItem encapsulates a single reminder to edit
 * Please refer to ReminderList for details
 */
export default {
  components: {
    MessageTypeSelect, EmailInput, MobilePhoneInput
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    reminder: {
      type: Object,
      required: true
    },
    realTime: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    disableType: {
      type: Boolean,
      default: false
    },
    defaultPhone: {
      type: String
    },
    defaultEmail: {
      type: String
    },
    emailPrefillHint: {
      type: String
    },
    phonePrefillHint: {
      type: String
    },
    minutePickerProps: {
      type: Object,
      default: () => {
        return {}
      }
    },
    emailSuggestions: {
      type: Array,
      default: () => {
        return []
      }
    },
    phoneSuggestions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  emits: ['emailFocus', 'phoneFocus', 'remove'],
  methods: {
    onChangeType () {
      this.reminder.value = null
    }
  }
}
</script>
